import * as Sentry from '@sentry/nuxt'

const { sentry } = useRuntimeConfig().public

Sentry.init({
  dsn: sentry.dsn,
  sendDefaultPii: true,
  tracesSampleRate: Number(sentry.tracesSampleRate),
})
